import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'
import { AdapterConfigureGenerico } from '../../AdapterConfigureGenerico'
import { PERU_9112_TOAOrderPreliquidacion } from './PERU_9112_TOAOrderPreliquidacion'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { PERU_9112_WINOrder } from './PERU_9112_WINOrder'
import { PERU_9112_FibramasOrder } from './PERU_9112_FibramasOrder'
import { PERU_9112_WaooOrder } from './PERU_9112_WaooOrder'
import { PERU_9112_TuvesOrder } from './PERU_9112_TuvesOrder'
import { ESPAÑA_1729_SomacylOrder } from './ESPAÑA_1729_SomacylOrder'
import { PERU_9112_MiFibraOrder } from './PERU_9112_MiFibraOrder'
import { PERU_9112_BantelOrder } from './PERU_9112_BantelOrder'
import { PERU_9112_ClaroOrder } from './PERU_9112_ClaroOrder'

export const atcApi = createApi({
    reducerPath: 'atcApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AdapterConfigureGenerico.URL_BASE_ATC,
        prepareHeaders: (headers) => {
            headers.set('Content-Type', 'application/json')
            headers.set('request-decrypt-response', 'true')
            return headers
        },
    }),
    tagTypes: [
        'TOAOrders',
        'WINOrders',
        'FibramasOrders',
        'WaooOrders',
        'TuvesOrders',
        'SomacylOrders',
        'MiFibraOrders',
        'BantelOrders',
        'ClaroOrders'
    ],
    endpoints: (build) => ({
        ...PERU_9112_TOAOrderPreliquidacion(build),
        ...PERU_9112_WINOrder(build),
        ...PERU_9112_FibramasOrder(build),
        ...PERU_9112_WaooOrder(build),
        ...PERU_9112_TuvesOrder(build),
        ...ESPAÑA_1729_SomacylOrder(build),
        ...PERU_9112_MiFibraOrder(build),
        ...PERU_9112_BantelOrder(build),
        ...PERU_9112_ClaroOrder(build)
    })
})

export type AtcApiBuilder = EndpointBuilder<
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>,
    'TOAOrders' |
    'WINOrders' |
    'FibramasOrders' |
    'WaooOrders' |
    'TuvesOrders' |
    'SomacylOrders' |
    'MiFibraOrders' |
    'BantelOrders' |
    'ClaroOrders',
    'atcApi'
>;

export const {
    useGetByIdTOAOrdersQuery,
    useLazyGetByIdTOAOrdersQuery,
    useLazyGetTransitTOAOrdersQuery,
    useAddInventoryTOAOrdersMutation,
    useDeleteInventoryTOAOrdersMutation,
    useSendReviewTOAOrdersMutation,
    useGetByIdWINOrdersQuery,
    useLazyGetByIdWINOrdersQuery,
    useLazyGetTransitWINOrdersQuery,
    useAddInventoryWINOrdersMutation,
    useFinalizeWINOrdersMutation,
    useDeleteInventoryWINOrdersMutation,
    useGetByIdFibramasOrdersQuery,
    useLazyGetByIdFibramasOrdersQuery,
    useLazyGetTransitFibramasOrdersQuery,
    useAddInventoryFibramasOrdersMutation,
    useFinalizeFibramasOrdersMutation,
    useDeleteInventoryFibramasOrdersMutation,
    useGetByIdWaooOrdersQuery,
    useLazyGetByIdWaooOrdersQuery,
    useLazyGetTransitWaooOrdersQuery,
    useAddInventoryWaooOrdersMutation,
    useFinalizeWaooOrdersMutation,
    useDeleteInventoryWaooOrdersMutation,
    useGetByIdTuvesOrdersQuery,
    useLazyGetByIdTuvesOrdersQuery,
    useFinalizeTuvesOrdersMutation,
    useAddInventoryTuvesOrdersMutation,
    useDeleteInventoryTuvesOrdersMutation,
    useLazyGetTransitTuvesOrdersQuery,
    useGetByIdSomacylOrdersQuery,
    useLazyGetByIdSomacylOrdersQuery,
    useFinalizeSomacylOrdersMutation,
    useAddInventorySomacylOrdersMutation,
    useDeleteInventorySomacylOrdersMutation,
    useLazyGetTransitSomacylOrdersQuery,
    useUploadPhotosSomacylOrdersMutation,
    useUploadPhotosWINOrdersMutation,
    useGetByIdMiFibraOrdersQuery,
    useLazyGetByIdMiFibraOrdersQuery,
    useLazyGetTransitMiFibraOrdersQuery,
    useAddInventoryMiFibraOrdersMutation,
    useDeleteInventoryMiFibraOrdersMutation,
    useFinalizeMiFibraOrdersMutation,
    useGetByIdBantelOrdersQuery,
    useLazyGetByIdBantelOrdersQuery,
    useLazyGetTransitBantelOrdersQuery,
    useAddInventoryBantelOrdersMutation,
    useFinalizeBantelOrdersMutation,
    useDeleteInventoryBantelOrdersMutation,
    useUploadPhotosMiFibraOrdersMutation,
    useUploadPhotosFibramasOrdersMutation,
    useUploadPhotosBantelOrdersMutation,
    useGetByIdClaroOrdersQuery,
    useLazyGetByIdClaroOrdersQuery,
    useLazyGetTransitClaroOrdersQuery,
    useAddInventoryClaroOrdersMutation,
    useFinalizeClaroOrdersMutation,
    useDeleteInventoryClaroOrdersMutation,
    useUploadPhotosClaroOrdersMutation,
} = atcApi
